import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetDistinctSensorsDataResData } from "./GetDistinctSensorsDataResData";

const ENDPOINT = "/fitness_statistics/distinct_sensors_data"

export class GetDistinctSensorsDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetDistinctSensorsDataResData> {
        var res = await this.executeCommand(null, null);
        return new GetDistinctSensorsDataResData(res);
    }

}